import { useEffect, useMemo, useState } from "react"
import { Nav, Tab } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useParams } from "react-router"
import { useSearchParams } from "react-router-dom"

import Loading from "@/components/Loading/Loading"
import { useEnrolledByIdData } from "@/queries/queries"
import { getEmbedUrl } from "@/utils/helpers"

export default function VideosShow() {
  const { t } = useTranslation()
  const { lectureId } = useParams()
  const [params] = useSearchParams()

  const lectureType = params.get("type")

  const enrolledRoundQuery = useEnrolledByIdData()

  const videos =
    enrolledRoundQuery?.data?.data?.lectures?.find(
      (l) => l.id === Number(lectureId) && l.type === Number(lectureType)
    )?.lecture_videos || []

  const [activeKey, setActiveKey] = useState<string>()

  useEffect(() => {
    if (videos.length && !activeKey) {
      setActiveKey(videos[0].id.toString())
    }
  }, [videos, activeKey])

  const currentVideo = useMemo(
    () => videos.find((v) => v.id.toString() === activeKey),
    [videos, activeKey]
  )

  const embed = getEmbedUrl(currentVideo?.url)
  if (enrolledRoundQuery.isLoading) {
    return <Loading />
  }
  if (!videos.length) {
    return (
      <p className="text-danger">{t("enrolledCoursesPage.videos.noData")}</p>
    )
  }

  return (
    <div className="container-fluid py-4">
      <Tab.Container
        activeKey={activeKey}
        onSelect={(k) => setActiveKey(k || "")}
      >
        <Nav variant="tabs" className="mb-4 flex-nowrap overflow-auto">
          {videos.map((video) => (
            <Nav.Item key={video.id}>
              <Nav.Link eventKey={video.id.toString()}>
                {video.title ||
                  `${t("enrolledCoursesPage.videos.video")} ${video.id}`}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>

        <Tab.Content>
          <Tab.Pane eventKey={activeKey}>
            {embed ? (
              embed.type === "direct" ? (
                <video
                  src={embed.url}
                  controls
                  autoPlay
                  className="w-100 rounded"
                  style={{ maxHeight: "80vh" }}
                />
              ) : (
                <div className="ratio ratio-16x9 mb-3">
                  <iframe
                    src={embed.url}
                    title={"videoPlayer"}
                    allow="autoplay"
                    allowFullScreen
                    style={{ border: 0, width: "100%", height: "100%" }}
                  />
                </div>
              )
            ) : (
              <p className="text-danger">
                {t("driveVideoPreview.errors.invalid")}
              </p>
            )}
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </div>
  )
}
